import React, { useEffect, useState } from "react";
import { Box, Typography, Switch, Stack, Button } from "@mui/material";
import { SideBar } from "../../components/shared/sideBar/sideBar";
import { useAppTheme } from "../../components/themes/appThemeProvider";
import sideBarStyles from "../../components/shared/sideBar/sideBar.module.css";

export const TenableViewSideBar = ({}) => {
  return (
    <SideBar>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          width: "100%",
          padding: 0,
          gap: 2,
        }}
      ></Box>
    </SideBar>
  );
};
